{
  "nav": {
    "dashboard": "Tableau de bord",
    "teacherDashboard": "Mes sessions",
    "projects": "Projets",
    "fairQuote": "Fair Quote",
    "exitFairQuote": "Quitter Fair Quote",
    "contacts": "Contacts",
    "entities": "Entités",
    "products": "Produits",
    "colors": "Couleurs",
    "courses": "Formations",
    "teachers": "Professeurs",
    "students": "Élèves",
    "certifications": "Certifications",
    "staff": "Équipe",
    "company": "Ma société",
    "overview": "Vue d'ensemble",
    "sections": {
      "projects": "Projets",
      "shop": "Boutique & Catalogue",
      "entity": "Espace entité",
      "learning": "Formation",
      "admin": "Administration"
    },
    "enrollments": "Inscriptions",
    "calendar": "Calendrier",
    "userManagement": "Utilisateurs",
    "applicatorProfiles": "Fiches applicateurs",
    "certificationDefinitions": "Définitions certifications",
    "switchEntity": "Changer d'entité"
  }
}
